import { AddressType } from '@steelbuy/ts-shared';
import { useGetAddress } from './getAddress';
import { FilterComparator, SortDirection } from '../../utils/types';

type FilterPayload = {
    addressType?: string;
    enabled?: boolean;
};

export const useGetWarehouseAddress = (payload?: FilterPayload) =>
    useGetAddress({
        limit: 100,
        offset: 0,
        enabled: payload?.enabled,
        filter: [
            {
                property: 'addressType',
                comparator: FilterComparator.EQUAL,
                value: payload?.addressType ?? AddressType.WAREHOUSE,
            },
        ],
        sort: [
            {
                property: 'primary',
                direction: SortDirection.DESCENDING,
            },
            {
                property: 'postalCode',
                direction: SortDirection.ASCENDING,
            },
        ],
    });
